import { target2field } from "../../shared/utils/target-to-field";
import { FieldMap, UiName } from "../../shared/types";

export function mapDlTargetToLastenoverzichtUiField(target: string): UiName | null {
  const map: FieldMap<any> = {};

  return target2field(map, target);
}
